import axios from 'axios';
import { DealDocumentCopyHistoryModel, DealDocumentCopyRequestModel } from '@/types';

const dealDocumentCopyApiUrl = 'automotive/dealDocument';

export const DealDocumentCopyService = {
  async getDealCopyHistoryAsync(): Promise<DealDocumentCopyHistoryModel[]> {
    const response = await axios.get(`${dealDocumentCopyApiUrl}/DealCopyHistory`);
    return response.data;
  },

  async createDealCopyRequestAsync(dealDocumentCopyRequest: DealDocumentCopyRequestModel) {
    const response = await axios.post(`${dealDocumentCopyApiUrl}/DealCopyRequest`, dealDocumentCopyRequest);
    return response.data;
  }
};